import React from 'react';

const variants = {
  primary: 'ui-btn-primary',
  secondary: 'ui-btn-secondary',
  ghost: 'ui-btn-ghost',
  danger: 'ui-btn-danger',
  success: 'ui-btn-success',
};

const sizes = {
  sm: 'ui-btn-sm',
  md: 'ui-btn-md',
  icon: 'ui-btn-icon',
};

export default function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  type = 'button',
  loading = false,
  disabled = false,
  ...props
}) {
  return (
    <button
      type={type}
      className={`ui-btn ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <span className="spinner spinner-light" /> : children}
    </button>
  );
}
